'use client';

import React from 'react';

const PaymentRedirectTastic = () => {
  return <h1>Hello World</h1>;
};

export default PaymentRedirectTastic;
